export const features = {
  workflowRoleExport: false,
  hiddenLinks: [],
  hiddenLandingPageOptions: [],
};
